import React from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaTools } from "react-icons/fa";
import { Link } from "react-router-dom";
import stock_dashboard from "../../image/project/stock_dashboard.png";
import stock_analytics from "../../image/project/stock-analytics.png";
import intelistock_vector from "../../image/project/intelistock-vector.png";
import shuttle_das from "../../image/project/shuttle-dashboard.png";
import shuttle_bus from "../../image/project/shuttle-bus.png";
import qms_das from "../../image/project/qms-das.png";
import qms_report from "../../image/project/qms-report.png";
import pass_das from "../../image/project/pass-das.png";
import pass_report from "../../image/project/pass-report.png";
import pass_vector from "../../image/project/pass-vector.png";
import shuttle_vector from "../../image/project/shuttle-vector.png";
import qms_vector from "../../image/project/qms-vector.png";
import track_vector from "../../image/project/track-vector.png";
import doc_vector from "../../image/project/doc-vector.png";
import doc_dashboard from "../../image/project/doc-dashboard.png";
import doc_report from "../../image/project/doc-report.png";
const projects = {
  intelidoc: {
    title: "inteliDoc",
    subtitle: "Smart Document & Drawing Management System (DMS/ODMS)",
    description: [
      "inteliDoc is a secure and scalable platform for managing, organizing, and retrieving engineering drawings, technical documents, inspection reports, and other critical records. It is implemented across industries as a Document Management System (DMS) or specifically as an Online Drawing Management System (ODMS).",
      "The system replaces manual tracking and costly paper printing by offering centralized digital access, secure role-based controls, and automated workflows for uploads, versioning, approvals, and metadata handling.",
    ],
    features: [
      "Supports engineering files like PDFs, .DWG, Excel, and scanned blueprints (A0–A4)",
      "Centralized access with role-based permission and audit trails",
      "Smart search by drawing number, project, department, or revision",
      "Automated versioning and support for digital signatures",
      "Seamless integration with QMS and ERP systems for compliance workflows",
    ],
    objectives: [
      "Centralized document lifecycle control",
      "Secure, role-based access with auditability",
      "Minimize manual tracking and printing costs",
      "Ensure compliance with industry standards",
    ],
    goals: [
      "Faster document retrieval and approval cycles",
      "Improved traceability of engineering revisions",
      "Enhanced data security and compliance readiness",
    ],
    techStack: ["React", "Node.js", "MongoDB"],
    images: {
      vector_img: doc_vector,
      dashboard: doc_dashboard,
      illustration: doc_report,
    },
    dashboard_desc:
      "The inteliDoc dashboard provides a centralized view of all technical documentation workflows, including upload status, version history, approval stages, and metadata tagging. It offers project-wise document traceability, role-based access logs, and compliance alerts. The interface is optimized for quick search, collaborative reviews, and secure document lifecycle management.",
    illustration_desc:
      "This illustration visualizes the inteliDoc ecosystem—showcasing secure document repositories, user role icons, technical drawings, approval workflows, and digital signatures. It highlights engineers and managers reviewing documents on tablets and desktops, demonstrating streamlined digital access, version tracking, and centralized control of engineering and inspection records.",
  },
  intelipass: {
    title: "InteliPass",
    subtitle: "Smart Visitor & Access Control System",
    description: [
      "InteliPass is a secure visitor and access control platform designed to digitize gate entries, employee check-ins, and visitor pass workflows using facial recognition, QR code scanning, and integration with drop-arm barriers or gate controls.",
      "Built for industrial campuses, government facilities, and defense labs, it enhances security and improves visitor experience with mobile/web interfaces for pre-approval, gate logging, and central reporting.",
    ],
    objectives: ["Secure identity verification", "Access management"],
    features: [
      "Face recognition or QR code-based authentication at entry points",
      "Pre-registered visitor approval workflows via email/SMS/mobile",
      "Drop-arm or boom barrier control integration for physical access",
      "Dashboard for guards, security heads, and department admins",
      "Daily visitor logs, pass expiry controls, and entry history",
    ],
    goals: ["Faster gate entry", "Improved security"],
    techStack: ["React", "Node.js", "MongoDB"],
    images: {
      vector_img: pass_vector,
      dashboard: pass_das,
      illustration: pass_report,
    },
    dashboard_desc:
      "The InteliPass dashboard provides a real-time control center for managing visitor and employee access. It includes live gate entry logs, visitor approvals, pass statuses, and barrier control status, allowing guards, security heads, and department admins to monitor and act on access requests instantly, ensuring security across all entry points.",
    illustration_desc:
      "The system illustration visually demonstrates InteliPass in action—depicting a visitor at a security gate using facial recognition or QR code for entry. It shows integration with boom barriers and centralized approval workflows, highlighting seamless coordination between security teams and digital identity verification through mobile or web-based platforms.",
  },

  intelistock: {
    title: "Intelistock",
    subtitle: "AI-Based Inventory Management System",
    description: [
      "Intelistock is a powerful AI-driven inventory management platform built to deliver real-time traceability, demand forecasting, GRN-based item tracking, stock alerts, and inter-department stock visibility.",
      "It supports barcode/QR-based GRN entries, consumption logs, predictive restocking, stock aging, and ERP integration for data-driven procurement.",
    ],
    objectives: [
      "Real-time stock visibility across multiple warehouses",
      "Predictive restocking using AI/ML",
      "Automated alerts and threshold monitoring",
      "Role-based access and permission controls",
    ],
    features: [
      "Role-based access and action history for accountability",
      "Stock age analysis, fast/slow-moving item tagging",
      "Department/plant/section-wise usage reports",
      "Offline-first PWA capability for remote stores",
      "Custom integrations with ERP, procurement & maintenance modules",
    ],
    goals: [
      "✅ Intelligent forecasting",
      "✅ Threshold alerting",
      "✅ ERP-ready architecture",
      "⏳ Smart analytics (in progress)",
    ],
    techStack: [
      "Frontend: React + SCSS",
      "Backend: Django REST API",
      "DB: PostgreSQL",
      "AI Layer: Python + TensorFlow",
    ],
    images: {
      vector_img: intelistock_vector,
      dashboard: stock_dashboard,
      illustration: stock_analytics,
    },
    dashboard_desc:
      "The Intelistock dashboard showcases real-time inventory data, stock levels, consumption trends, and AI-based restocking predictions. It provides department-wise visibility, threshold alerts, GRN traceability, and quick insights into fast- or slow-moving items. Users can manage inventory operations efficiently and forecast needs using dynamic reports and AI-powered analytics.",
    illustration_desc:
      "This illustration features the Intelistock ecosystem with warehouse shelves, barcode scanners, inventory dashboards, and AI graphs to show predictive analytics. It represents stock managers receiving low-stock alerts, logging GRNs, and tracking items across departments—giving a visual cue of seamless, intelligent stock control from procurement to consumption.",
  },

  inteliqms: {
    title: "InteliQMS",
    subtitle: "Digital Quality Management System (QMS)",
    description: [
      "InteliQMS helps automate quality assurance processes for complex manufacturing, defense, and aerospace workflows.",
      "It supports checklists, ATP/P-SAC generation, NCR tracking, version control, and audit logs aligned with protocols like DO-178C/DO-254.",
    ],
    objectives: ["Digitize QA forms", "Comply with defense audit protocols"],
    features: [
      "Digital ATP/P-SAC generation with template support",
      "Checklists, validation forms, and QA sign-offs",
      "NCR logging, CAPA workflows, and closure tracking",
      "Version control, reviewer logs, and traceability index",
      "Reporting dashboards and compliance indicators",
    ],
    goals: ["Regulatory compliance", "Process traceability"],
    techStack: ["React", "Django", "SQLite"],
    images: {
      vector_img: qms_vector,
      dashboard: qms_das,
      illustration: qms_report,
    },
    dashboard_desc:
      "The InteliQMS dashboard allows QA professionals to manage ATPs, checklists, NCRs, and compliance documents in one place. It displays approval statuses, audit logs, and version histories to streamline quality assurance processes. Role-based views ensure that each stakeholder sees tasks relevant to them, improving traceability and regulatory readiness.",
    illustration_desc:
      "The system illustration represents the flow of digital quality management—from initial inspection checklists to NCR reporting and final ATP generation. It shows engineers using tablets to validate tasks, managers reviewing sign-offs, and traceability paths linking every quality event to documents, ensuring compliance with aerospace or defense standards.",
  },

  intelitrack: {
    title: "InteliTrack",
    subtitle: "Smart Logistics & Asset Tracking System",
    description: [
      "InteliTrack combines RFID, GPS, and IoT technologies to enable real-time monitoring and control over critical assets, tools, spares, and consumables.",
      "The platform offers check-in/out history, geo-fencing, asset life analytics, and seamless ERP/inventory integration.",
    ],
    objectives: ["Track vehicle & assets in real time"],
    features: [
      "RFID/QR/LoRa tagging and mobile scanning apps",
      "Live dashboard with asset location, status, and last movement",
      "Check-in/out history, damage/maintenance reporting",
      "Threshold alerts, asset grouping, and tool crib management",
      "Analytics on idle assets, asset life, and utilization",
    ],
    goals: ["Zero lost inventory", "Live dashboards"],
    techStack: ["React", "IoT Gateway", "PostgreSQL"],
    images: {
      vector_img: track_vector,
      dashboard: "/images/intelitrack-dashboard.png",
      illustration: "/images/intelitrack-cartoon.png",
    },
    dashboard_desc:
      "The InteliTrack dashboard offers live visualization of assets and vehicles using GPS and RFID data. It features interactive maps, movement logs, maintenance status, and alerts for idle or misplaced items. The system improves visibility across logistics by displaying each asset’s journey, usage history, and current condition in real time.",
    illustration_desc:
      "The illustration depicts a smart logistics setup with tagged assets, vehicles, and workers using mobile devices to scan and log activity. It shows real-time asset movement across facilities, automated gate check-ins, and integration with IoT sensors, emphasizing secure and trackable operations through centralized control.",
  },

  intelishuttle: {
    title: "InteliShuttle",
    subtitle: "AI-Powered Bus Tracking and Access Control System",
    description: [
      "InteliShuttle is a GPS and facial recognition-enabled access platform designed to monitor bus boarding, automate employee check-ins, and track shuttle fleet operations in large industrial campuses.",
      "It offers secure boarding, ETA prediction, stop-wise attendance, and centralized dashboards for transport and HR.",
    ],
    objectives: ["Efficient employee transport"],
    features: [
      "Face or QR-based boarding authentication",
      "GPS tracking of shuttle buses with ETA prediction",
      "Geo-fencing alerts and stop-wise analytics",
      "Central dashboard for transport and HR teams",
      "Attendance sync, pass validation, and driver logs",
    ],
    goals: ["Better commute visibility"],
    techStack: ["React Native", "Node.js", "Firebase"],
    images: {
      vector_img: shuttle_vector,
      dashboard: shuttle_das,
      illustration: shuttle_bus,
    },
    dashboard_desc:
      "The InteliShuttle dashboard centralizes shuttle tracking, attendance, and ETA information. It shows stop-wise boarding records, driver check-ins, route optimization, and geo-fencing alerts. HR and transport teams can monitor shuttle compliance, validate passes, and ensure safe employee transport with real-time visibility and predictive analytics.",
    illustration_desc:
      "This visual illustrates employees boarding AI-powered buses using facial recognition at defined stops. Buses are tracked on a digital map while HR/transport teams view boarding data and estimated arrivals. The scene demonstrates how InteliShuttle combines GPS, attendance tracking, and automation to streamline large-scale transport operations.",
  },
};

const SolutionDetails = () => {
  const { name } = useParams();
  const project = projects[name?.toLowerCase()];

  if (!project) {
    return (
      <div style={{ minHeight: "100vh" }}>
        <Container className="text-center" style={{ padding: "120px 0" }}>
          <h2 className="text-danger">Project Not Found</h2>
          <p className="text-muted">
            Please check the URL or try another project.
          </p>
        </Container>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh" }}>
      <section id="project-details" className="bg-white">
        {/* HERO SECTION */}
        {/* <div
          className="text-white"
          style={{
            padding: "6rem 0",
            background: "linear-gradient(90deg, #ff6b00, #ff9232)",
          }}
        >
          <Container>
            <Row className="justify-content-center text-center">
              <Col md={10} lg={8}>
               
                <div className="mb-4" data-aos="fade-up" data-aos-delay="100">
                  {project.icon}
                </div>

               
                <h1
                  className="display-4 fw-bold"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  {project.title}
                </h1>

          
                <h5
                  className="text-white-50 fw-medium mb-4"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  {project.subtitle}
                </h5>

               
                <div className="mb-4">
                  {project.description.map((para, idx) => (
                    <p
                      key={idx}
                      className="fs-6 text-white-75 mb-2"
                      data-aos="fade-up"
                      data-aos-delay={400 + idx * 100}
                    >
                      {para}
                    </p>
                  ))}
                </div>

             
                <div className="mt-4" data-aos="zoom-in" data-aos-delay="700">
                  <h5 className="fw-bold mb-2">
                    See {project.title} in Action
                  </h5>
                  <p className="mb-3 text-white-50">
                    Get a personalized walkthrough tailored to your
                    organization’s needs.
                  </p>
                  <Link to="/contact" className="btn btn-light btn-lg">
                    Request a Demo
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </div> */}

        <div
          className="bg-white"
          style={{
            padding: "9rem 0",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Container>
            <Row className="align-items-center g-5">
              <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                <div className="mb-4">
                  <h1 className="display-4 fw-bold text-dark mb-3">
                    {project.title}
                  </h1>
                  <h5 className="text-orange mb-4">{project.subtitle}</h5>

                  {project.description.map((para, idx) => (
                    <p key={idx} className="text-muted fs-6 mb-3">
                      {para}
                    </p>
                  ))}
                </div>

                <div className="mt-4">
                  <h5 className="fw-bold mb-2 text-dark">
                    See {project.title} in Action
                  </h5>
                  <p className="text-muted mb-3">
                    Get a personalized walkthrough tailored to your
                    organization's needs.
                  </p>
                  <Link
                    to="/contact"
                    className="btn btn-lg btn-outline-primary rounded-4"
                  >
                    Request a Demo
                  </Link>
                </div>
              </Col>

              <Col
                md={6}
                className="d-none d-md-block"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <img
                  src={project.images.vector_img}
                  alt={`${project.title}`}
                  className="img-fluid"
                  style={{ objectFit: "cover" }}
                />
              </Col>
            </Row>
          </Container>
        </div>

        {/* DASHBOARD VISUAL */}
        <div className="dashboard-preview-section py-5">
          <Container>
            <div className="row g-4 align-items-center">
              <Col
                md={6}
                data-aos="fade-right"
                data-aos-delay="100"
                data-aos-duration="1000"
              >
                <img
                  src={project.images.dashboard}
                  alt={`${project.title} Dashboard`}
                  className="img-fluid rounded-3 shadow-sm"
                  style={{ objectFit: "cover" }}
                />
              </Col>

              <Col
                md={6}
                data-aos="fade-left"
                data-aos-delay="200"
                data-aos-duration="1000"
              >
                <h3 className="fw-bold text-dark mt-4 mb-3">
                  Dashboard Preview
                </h3>
                <p className="text-muted">{project.dashboard_desc || "-"}</p>
              </Col>
            </div>
          </Container>
        </div>
        <div className="dashboard-preview-section py-5">
          <Container>
            <div className="row g-4 align-items-center">
              <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                <h3 className="fw-bold text-dark mt-4 mb-3">
                  System Illustartion
                </h3>
                <p className="text-muted">{project.illustration_desc || "-"}</p>
              </Col>
              <Col
                md={6}
                data-aos="fade-left"
                data-aos-delay="100"
                data-aos-duration="1000"
              >
                <img
                  src={project.images.illustration}
                  alt={`${project.title} Dashboard`}
                  className="img-fluid rounded-3 shadow-sm"
                  style={{ objectFit: "cover" }}
                />
              </Col>
            </div>
          </Container>
        </div>

        {/* FEATURES + OBJECTIVES GRID */}
        <div className="py-5 mt-3">
          <Container>
            <Row className="g-4">
              <Col
                md={6}
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1000"
              >
                <div className="bg-light rounded-4 p-4 shadow-sm h-100">
                  <h5 className="text-orange fw-bold mb-3">
                    Project Objectives
                  </h5>
                  <ul className="text-muted small ps-3 mb-0">
                    {project.objectives.map((item, idx) => (
                      <li key={idx} className="mb-2">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col
                md={6}
                data-aos="fade-up"
                data-aos-delay="200"
                data-aos-duration="1000"
              >
                <div className="bg-light rounded-4 p-4 shadow-sm h-100">
                  <h5 className="text-orange fw-bold mb-3">Key Features</h5>
                  <ul className="text-muted small ps-3 mb-0">
                    {project.features.map((item, idx) => (
                      <li key={idx} className="mb-2">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* TECH STACK + GOALS */}
        <Container className="py-5">
          <Row className="g-4">
            <Col
              md={6}
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="1000"
            >
              <div className="bg-light rounded-4 p-4 shadow-sm h-100">
                <h5 className="text-orange fw-bold mb-3">Technology Stack</h5>
                <ul className="text-muted small ps-3 mb-0">
                  {project.techStack.map((tech, idx) => (
                    <li key={idx} className="list-unstyled mb-2">
                      <FaTools className="me-2" /> {tech}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col
              md={6}
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="1000"
            >
              <div className="bg-light rounded-4 p-4 shadow-sm h-100">
                <h5 className="text-orange fw-bold mb-3">Project Goals</h5>
                <ul className="text-muted small ps-3 mb-0">
                  {project.goals.map((goal, idx) => (
                    <li key={idx} className="list-unstyled mb-2">
                      {goal}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>

      </section>
    </div>
  );
};

export default SolutionDetails;
